import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/student-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/StudentForm';
import { IStudent } from 'src/types/student';
import user from '../../../../../../services/user-auth';
import { routes } from '../../../../../../navigation';
import Breadcrumbs from 'src/components/Breadcrumbs';

export interface StateProps {
    student: IStudent | null;
    inProgress: boolean;
    files: any;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getFiles: (id: string | number) => void;
    addFiles: (id: string | number, requestType: string, files: any) => void;
    removeFile: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const StudentEditScreen: FC<Props> = (props: Props) => {
    const {
        student,
        match: {
            params: { id },
        },
        getFiles,
        files,
        addFiles,
        inProgress,
        removeFile,
        getData,
    } = props;

    useEffect(() => {
        if (!student || student.id !== id) {
            getData(id);
            getFiles(id);
        }
        // eslint-disable-next-line
    }, [getFiles, getData, id]);

    const handeAdd = (files: any, requestType: string) => {
        addFiles(id, requestType, files);
    };
    const handeRemove = (fileId: string | number) => {
        removeFile(fileId);
    };
    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        handleSubmit(e);
    };
    const arrStatValues: SelectObject[] = [];
    const studentStatuses: any = user.getStudentAvailableStatus();

    Object.keys(studentStatuses).forEach((key: string) => {
        arrStatValues.push({ label: key, value: studentStatuses[key] });
    });
    const statusValue = arrStatValues.find((it: SelectObject) => {
        if (it.value === student?.status) {
            return it;
        }
        return false;
    });

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'STUDENTS', path: routes.STUDENTS_LIST },
                    { name: `EDIT ${student?.firstName} ${student?.lastName}`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                {inProgress ? <Loader /> : !student ? <div></div> : null}
                <Form
                    statuses={arrStatValues}
                    files={files ? files : []}
                    handleSub={handleSub}
                    orderDoc={student?.orderDoc}
                    setOrderDoc={(files) => handeAdd(files, 'ORDER')}
                    removeOrderDoc={(id) => {
                        return false;
                    }}
                    consentDoc={student?.consentDoc}
                    setConsentDoc={(files: any) => handeAdd(files, 'CONSENT')}
                    removeConsentDoc={(id) => {
                        return false;
                    }}
                    parentConsentDoc={student?.parentConsentDoc}
                    setParentConsentDoc={(files: any) => handeAdd(files, 'PARENT_CONSENT')}
                    removeParentConsentDoc={(id) => {
                        return false;
                    }}
                    setFiles={(files: any) => handeAdd(files, 'OTHER')}
                    removeFile={(id) => handeRemove(id)}
                    initialValues={{ ...student, status: statusValue }}
                />
            </div>
        </AdminLayout>
    );
};
export default StudentEditScreen;
